'use client';

export default function EcoIconArrow({ className, ...reset }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            className={`bh-icon-arrow${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
